import { render, staticRenderFns } from "./PlansWrapper.vue?vue&type=template&id=f11ef0b8&scoped=true"
import script from "./PlansWrapper.vue?vue&type=script&lang=js"
export * from "./PlansWrapper.vue?vue&type=script&lang=js"
import style0 from "./PlansWrapper.vue?vue&type=style&index=0&id=f11ef0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11ef0b8",
  null
  
)

export default component.exports